import React from 'react'
import CommonHeroSection from '../../common/CommonHeroSection'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import Footer from '../../common/Footer'
import TicketSection from '../../sections/CommonSection/TicketSection'
import Header from '../../common/Header'
import flightTicketBookingImg from '../../../assets/our-services-img/flight-booking-img.jpg';

const FlightTicketBooking = () => {
    return (
        <>
            <Header />
            <CommonHeroSection title="Flight Ticket Booking" />
            <CommonBreadcrumb items={["Flight Ticket Booking"]} />
            <TicketSection
                title="Flight Ticket Booking"
                description={[
                    `At Sudarshan Holidays, we became extremely popular and got the appreciation and trust of our clients in a very short span due to our incredible travel solutions. Flight booking service is surely one of them. When it comes to the matter of booking flight tickets, most people often confront different issues to execute the entire task without fail. If you are also one among them, take professional help from us.`,

                    `Being one of the well-known travel agencies in Bangalore, Karnataka we offer an effective flight booking service with 100% assertion. Our agency possesses highly trained professionals who can seamlessly function to book air tickets of your preferred airlines at a low price. No matter what would be the requirement is, whether you want a business class or economy class flight booking, we can deliver any of them.`,

                    `Hence contact Sudarshan Holidays to get your flight tickets with the best deals and cashback before your much-awaited Bangalore trip.`
                ]}
                image={flightTicketBookingImg}
            />
            <Footer />
        </>
    )
}

export default FlightTicketBooking